import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { AiOutlineSearch } from "react-icons/ai";
import { Container } from './userInfoStyled';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'
import { Table } from 'reactstrap';
import { MdKeyboardBackspace } from "react-icons/md";
import styled from 'styled-components';
import {Heading, TableWrapper , SubHeading} from 'web/pages/private/Admin/adminStyled'

const ReferralCodeDetails = ({ togglePage, referralDetails }) => {

    const UsedTableHeaderArray = ['User', 'Used Date', 'User Type']
    const UnusedTableHeaderArray = ['Email', 'Invited On', 'Status', 'User Type']
    const [usedReferralList, setUsedReferralList] = useState([])
    const [unUsedReferralList, setUnUsedReferralList] = useState([])
    const [referralCodeName, setReferralCodeName] = useState('')

    useEffect(() => {
        if (referralDetails !== undefined && referralDetails.payload.length > 0) {
            setUsedReferralList(referralDetails.payload.filter(val => val.joined))
            setUnUsedReferralList(referralDetails.payload.filter(val => !val.joined))
            setReferralCodeName(referralDetails.payload[0].referralCode)
        }
    }, [])

    return (
        <div>
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', cursor: 'pointer' }}
                onClick={() => togglePage()}
            />
            <Container>
                <TableWrapper>
                    <Heading>
                        <h3>{`${referralCodeName} (${referralDetails && referralDetails.message})`}</h3>
                        <SearchWrapper>
                            <input type="text" placeholder='Search' />
                            <AiOutlineSearch />
                        </SearchWrapper>
                    </Heading>
                    <SubHeading>
                        <h4>Used List</h4>
                    </SubHeading>
                    <Table responsive>
                        <thead>
                            <tr>
                                {UsedTableHeaderArray.map((items, index) => (
                                    <th key={index}>{items}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {usedReferralList && usedReferralList.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.user}</td>
                                    <td>{items.joinedAt && items.joinedAt.substring(0, 10)}</td>
                                    <td>{items.userType}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <SubHeading>
                    <h4>Unused List</h4>
                    </SubHeading>
                    <Table responsive>
                        <thead>
                            <tr>
                                {UnusedTableHeaderArray.map((items, index) => (
                                    <th key={index}>{items}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {unUsedReferralList && unUsedReferralList.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.referredEmailId}</td>
                                    <td>{items.invitedAt && items.invitedAt.substring(0, 10)}</td>
                                    <td>{items.registrationStatus}</td>
                                    <td>{items.userType !== null ? items.userType : 'NA'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </TableWrapper>

            </Container>
        </div >
    )
};

export default ReferralCodeDetails;